module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-invitation-0b6d24e6278422f0fca7b0a1b9b28ff7.png";